export default __webpack_public_path__ + "static/animationbackground-8a784820da7b4e49b8a7a27803ede96d.svg";